var React = require('react');

function IcnArrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_25_241)","key":0},React.createElement("path",{"d":"M25.6862 7.76206L18.0564 0.342694C17.5869 -0.113824 16.8256 -0.113824 16.3561 0.342694C15.8867 0.799212 15.8867 1.53965 16.3561 1.99617L21.8414 7.33055H1.20251C0.538238 7.33055 0 7.85398 0 8.49999C0 9.14599 0.538238 9.66943 1.20251 9.66943H21.842L16.3568 15.0038C15.8873 15.4603 15.8873 16.2008 16.3568 16.6573C16.8262 17.1138 17.5876 17.1138 18.057 16.6573L25.6869 9.2373C26.1061 8.83018 26.1061 8.16917 25.6869 7.76206H25.6862Z","fill":"#000"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_25_241"},React.createElement("rect",{"width":"26","height":"17","fill":"white"})))]);
}

IcnArrow.defaultProps = {"width":"26","height":"17","viewBox":"0 0 26 17","fill":"none"};

module.exports = IcnArrow;

IcnArrow.default = IcnArrow;
